<template>
  <div class="callback-container">
    <div v-if="loading" style="text-align: center;">
      <img src="../../assets/spinner.svg" alt="loading" style="margin:auto;">
    </div>
    <div v-if="verifyEmailError" class="verify-email">
      Please verify your email before logging in.<br/>
      A verification link has been sent to your address.
    </div>
    <div v-if="err && !verifyEmailError">
      Unfortuntely there was a problem during your login:
      <p class="err">{{ err }}</p>
      Please try again and <a href="mailto:support@simplystudio.com">let us know</a> if the problem persists.
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/authentication-service.js'

export default {
  name: 'Callback',
  data() {
    return {
      loading: true,
      err: null,
    }
  },
  async created() {
    let res = await AuthService.handleCallback()
      .catch(err => { 
        if(err.errorDescription == "`state` does not match.") {
          this.$router.push('/')
        }
        this.err = err
        this.loading = false
      })
    if(res && res.target) {
      this.$router.push(res.target)
    }
  },
  methods: {
  },
  computed: {
    verifyEmailError() {
      return this.err && this.err.errorDescription == 'Please verify your email before logging in.'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
.callback-container {
  padding: 100px 0px;
}
.err {
  color: $red;
}
.verify-email {
  margin: 100px 0px;
  font-size: 24px;
}
</style>